import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminServices() {
  return (
    <AdminCrud
      title="Serviços"
      resource="services"
      initialItem={{ icon: "BookOpen", status: "published", order: 0 }}
      fields={[
        { name: "name", label: "Nome do serviço", required: true },
        { name: "icon", label: "Ícone (lucide-react)", help: "Ex: BookOpen, LayoutTemplate, SpellCheck, Palette…" },
        { name: "image_url", label: "Imagem do serviço", type: "image" },
        { name: "short_description", label: "Descrição curta", textarea: true, rows: 2 },
        { name: "full_description", label: "Descrição completa", textarea: true, rows: 5 },
        { name: "price", label: "Preço/valor (opcional)" },
        { name: "contact_link", label: "Link de contato" },
        { name: "featured", label: "Destaque na home", type: "checkbox" },
        { name: "order", label: "Ordem", type: "number" },
      ]}
      columns={[
        { name: "name", label: "Serviço" },
        { name: "icon", label: "Ícone" },
        { name: "order", label: "Ordem" },
      ]}
    />
  );
}
